<template>
  <div class="c-table">
    <!-- {{ tableOption.tableName}} -->
    <edit-table
      :option="tableOption"
      :loading="loading"
      :data="data || []"
      :disabled="disabled"
      :formDataAll="formDataAll"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @rowDel="handleRowDel"
    />
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import { getCustomDicts } from '../utils'

export default {
  components: {
    EditTable,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    formDataAll: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: null,
      loading: false,
    }
  },
  computed: {
    tableOption() {
      const option = this.option.tableOption || {}
      option.tableName=this.option.tableName||''
      option.menu =
        typeof option.menu === 'boolean'
          ? option.menu
          : !this.disabled && !option.disabled
      option.header =
        typeof option.header === 'boolean'
          ? option.header
          : !this.disabled && !option.disabled
      return option
    },
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        const res = e ? JSON.stringify(e) : ''
        this.$emit('input', res)
      },
    },
    value: {
      handler(e) {
        this.$nextTick(() => {
          if (typeof e === 'object') {
            this.data = e
          } else {
            this.data = e ? JSON.parse(e) : null
          }
        })
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    if (this.tableOption.defaultValueDictCode && !this.disabled && !this.data) {
      const dictCode = this.tableOption.defaultValueDictCode
      const props = this.tableOption.defaultValueProps
      const res = await getCustomDicts[dictCode]({}, {})
      const result = []
      res.forEach((item) => {
        if (props) {
          const p = {}
          Object.keys(props).forEach((key) => {
            const element = props[key]
            p[element] = item[key]
          })
          result.push(p)
        } else {
          result.push(item)
        }
      })
      this.data = result
    }
  },
  methods: {
    handleSubmit(done, row = {}) {
      done()
      const res = []
      if (Array.isArray(this.data)) {
        if (this.data.length <= 0) {
          const param = row
          param.id = 1
          this.data.push(param)
        } else {
          this.data.forEach((item, index) => {
            if (index === this.data.length - 1) {
              const param = row
              param.id = index + 1
              res.push(param)
            } else {
              res.push(item)
            }
          })

          this.data = res
        }
      } else {
        const param = row
        param.id = 1
        this.data = [param]
      }
    },
    handleUpdate(done, row = {}) {
      done()
      if (Array.isArray(this.data)) {
        const res = []
        this.data.forEach((item, index) => {
          if (index === row.id - 1) {
            res.push(row)
          } else {
            res.push(item)
          }
        })
        this.data = res
      } else {
        const param = row
        this.data = [param]
      }
    },
    handleRowDel(done, row = {}) {
      done()
      const res = []
      this.data.forEach((item) => {
        if (item.id !== row.id) {
          res.push(item)
        }
      })
      this.data = res.length <= 0 ? null : res
    },
  },
}
</script>

<style lang="scss">
.c-table {
  .edit-table {
    table {
      td,
      th {
        line-height: 18px;
      }
      .width-200 {
        width: 200px;
        min-width: 200px;
      }
      .align-center {
        text-align: center;
      }
    }
  }
}
</style>
